import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

// Require in a base component context
const requireComponent = [
    require.context(
        './layouts',
        false,
        /Layout[\w-]+\.vue$/
    ),
    require.context(
        './utils',
        false,
        /Bmr[\w-]+\.vue$/
    )
];

requireComponent.forEach(req => {
    req.keys().forEach(fileName => {
        // Get component config
        const componentConfig = req(fileName);

        // Get PascalCase name of component
        const componentName = upperFirst(
            camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
        );

        // Register component globally
        Vue.component(componentName, componentConfig.default || componentConfig);
    });
});



// WEBPACK FOOTER //
// ./src/components/_global.js